import { render, staticRenderFns } from "./PhotoCapturePrompt.vue?vue&type=template&id=0a571c06&lang=pug&"
import script from "./PhotoCapturePrompt.vue?vue&type=script&lang=js&"
export * from "./PhotoCapturePrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports